var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 55,
    viewBox: "0 0 69 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0403 31.0471C9.42795 25.2719 4.34987 8.18133 13.9577 2.1769C26.4489 -5.62982 31.9937 9.42085 35.1388 18.0063C33.1001 7.10739 47.4608 8.97328 47.102 21.5569C62.6374 9.12447 77.0078 30.5659 59.916 38.555C64.8885 39.0482 71.0297 42.4224 66.3992 47.7069C61.9115 52.8294 47.6504 53.3957 41.8619 53.7749C34.0096 54.2885 23.6027 54.3749 15.7696 53.3165C-11.8659 49.586 2.2524 15.6485 17.0403 31.0471Z",
    fill: "#ECE9FB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleCloud);
export default __webpack_public_path__ + "static/media/purple-cloud.9b983c009e17c5f39324134468fb09e0.svg";
export { ForwardRef as ReactComponent };